import { Button } from "react-bootstrap";
import styles from "../styles/style.module.scss";
import moment from "moment";
import { useEffect, useState } from "react";
import AddBulkEmail from "./modal/addBulkEmail";
import AddSingleEmail from "./modal/addSingleEmail";
import { functionService } from "../../../lib/functions";
import { useNavigate } from "react-router-dom";
import deleteImage from "../../../images/delete.svg";

const AssignCandidate = ({
  setTrainingData,
  trainingData,
  setCurrentStep,
  type,
  imageUpdate,
}) => {
  const [show, setShow] = useState(false);
  const [emailList, setEmailList] = useState([]);

  let navigate = useNavigate();
  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    setEmailList(trainingData.emails);
  }, [trainingData.emails]);

  const handleEmailDelete = ({ deleteIndex }) => {
    setTrainingData({
      ...trainingData,
      emails: trainingData.emails.filter(
        (emails, index) => index !== deleteIndex
      ),
    });
  };

  const addtraining = async ({
    duration,
    durationType,
    title,
    contentLink,
    discordLink,
    imageLink,
    masterBootcamp,
    maximumSeats,
    availableSeats,
    sessions,
    registrationLink,
    description,
    role,
    alternateName,
    emails,
    meetingKey,
    platformType,
    instanceId,
    trainingRecordingLink,
  }) => {
    const data = {
      trainingTitle: title,
      trainingDuration: {
        type: durationType,
        value: Number(duration),
      },
      discordLink: discordLink,
      contentLink: contentLink,
      maximumSeats: Number(maximumSeats),
      availableSeats: Number(availableSeats),
      imageLink: imageLink,
      masterBootcamp: type === "EDIT" ? undefined : masterBootcamp ? 1 : 0,
      startDateTime: moment(sessions[0]?.startDateTime).utc(),
      endDateTime: moment(sessions[sessions.length - 1]?.startDateTime)?.add(sessions[sessions.length - 1]?.duration, 'hours').utc(),
      registrationLink: registrationLink,
      description: description,
      role: role,
      alternateName: alternateName,
      sessions: sessions.map((currentSession) => {
        return {
          ...currentSession,
          duration: Number(currentSession.duration),
          startDateTime: currentSession.startDateTime,
        };
      }),
      emails: emails.map(({ email }) => {
        return email;
      }),
      meetingKey,
      platformType,
      instanceId,
      trainingRecordingLink,
    };

    if (type === "EDIT") {
      try {
        let { status } = await functionService.patch(
          `training/${trainingData.id}`,
          {
            ...data,
            imageLink: imageUpdate ? imageLink : undefined,
          }
        );

        if (status) {
          // navigate(`/training`, { replace: true });
        }
      } catch (error) {
        console.log({ error });
      }
    } else {
      try {
        let { status } = await functionService.post(`training/new`, {
          ...data,
        });

        if (status) {
          // navigate(`/training`, { replace: true });
        }
      } catch (error) {
        console.log({ error });
      }
    }
  };

  const deleteStudent = async ({ id }) => {
    if (id) {
      try {
        await functionService.remove(`training/student/${id}`);
      } catch (error) {
        console.log({ error });
      }
    }
  };

  const [addEmailError, setAddEmailError] = useState(false);
  useEffect(() => {
    if (emailList.length > 0) {
      setAddEmailError(false);
    }
  }, [emailList]);

  return (
    <div>
      <div className={styles.assignNewCandidateButton}>
        <h4>Assigned Candidates</h4>
        {type === "EDIT" ? (
          <Button variant="primary" onClick={() => setShow(true)}>
            + Assign single Candidates
          </Button>
        ) : (
          <Button variant="primary" onClick={() => setShow(true)}>
            + Assign Bulk Candidates
          </Button>
        )}
      </div>
      <div>
        <div>
          <div style={{ width: "100%", display: "flex" }}>
            <div
              style={{
                width: "50%",
                padding: "20px 15px",
                background: "#EDEFF1",
                borderBottom: "2px solid black",
              }}
            >
              Email Address
            </div>
            <div
              style={{
                width: "50%",
                padding: "20px 15px",
                background: "#EDEFF1",
                borderBottom: "2px solid black",
                textAlign: "center",
              }}
            >
              Action
            </div>
          </div>
          <div
            style={{
              height: "55vh",
              overflow: "Scroll",

              borderRadius: "10px",
            }}
          >
            {addEmailError ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <p style={{ fontSize: "20px", color: "red" }}>
                  Add atleast one email to continue
                </p>
              </div>
            ) : (
              emailList?.map(({ email, id }, index) => (
                <div style={{ width: "100%", display: "flex" }} key={id}>
                  <div
                    style={{
                      width: "50%",
                      padding: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {email}
                  </div>
                  <div
                    style={{
                      width: "50%",
                      padding: "15px",
                      borderBottom: "1px solid grey",
                      textAlign: "center",
                    }}
                  >
                    <img
                      onClick={() => {
                        handleEmailDelete({ deleteIndex: index });
                        deleteStudent({ id });
                      }}
                      style={{ cursor: "pointer" }}
                      src={deleteImage}
                      height={20}
                      width={20}
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <div className={styles.assignmentCompletionButton}>
        <Button
          onClick={() => setCurrentStep(1)}
          variant="primary"
          className={styles.cancel}
        >
          Back
        </Button>
        <Button
          onClick={() => {
            if (emailList.length > 0) {
              addtraining(trainingData);
            } else {
              setAddEmailError(true);
            }
          }}
          variant="primary"
          className={styles.save}
        >
          Save & Finish
        </Button>
      </div>
      {type === "EDIT" ? (
        <AddSingleEmail
          show={show}
          setShow={setShow}
          emailList={emailList?.toString()}
          setEmailList={setEmailList}
          handleClose={handleClose}
          setTrainingData={setTrainingData}
          trainingData={trainingData}
        />
      ) : (
        <AddBulkEmail
          show={show}
          setShow={setShow}
          emailList={emailList?.toString()}
          setEmailList={setEmailList}
          handleClose={handleClose}
          setTrainingData={setTrainingData}
          trainingData={trainingData}
        />
      )}
    </div>
  );
};

export default AssignCandidate;
